import { useNavigate } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { GibletInputArea } from './GibletInputArea';
import { NotificationBell } from '../NotificationBell';
import { EngageAction } from './GibletEngageMenu';

interface CreatorsGibletChatBarProps {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  onEngageAction: (action: EngageAction) => void;
  isLoading: boolean;
  connectedKBsCount: number;
  maxKBs: number;
}

export const CreatorsGibletChatBar = ({
  value,
  onChange,
  onSend,
  onEngageAction,
  isLoading,
  connectedKBsCount,
  maxKBs,
}: CreatorsGibletChatBarProps) => {
  const navigate = useNavigate();

  const leftExtraButtons = (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          onClick={() => navigate("/ispai-solutions")}
          size="icon"
          className="h-7 w-7 bg-green-700 hover:bg-green-700 text-white rounded-full"
          aria-label="Go to Marketplace"
        >
          <ShoppingCart className="h-3.5 w-3.5" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>Go to the Marketplace</p>
      </TooltipContent>
    </Tooltip>
  );

  const extraButtons = (
    <NotificationBell compact />
  );

  return (
    <div className="w-full max-w-2xl mx-auto">
      <GibletInputArea
        value={value}
        onChange={onChange}
        onSend={onSend}
        onEngageAction={onEngageAction}
        isLoading={isLoading}
        connectedKBsCount={connectedKBsCount}
        maxKBs={maxKBs}
        variant="bar"
        extraButtons={extraButtons}
        leftExtraButtons={leftExtraButtons}
      />
    </div>
  );
};
